module.exports = __webpack_public_path__ + "media/images/logo-0fcb139f74eae34318923d4a2686fbc4.svg";